import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async show() {
    return useAsyncData('withrawal-settings', () => this.call('/spa/withdrawal'))
  }

  async update(data: any) {
    return this.call('/spa/withdrawal', {
      method: 'put',
      body: data,
    })
  }
}
